import * as z from 'zod';

import { isoDateTimeToMoment } from './codecs/moment';

import { AttachmentSchema } from './common/attachment';
import { SourceSchema } from './common/sources';
import { SystemSchema } from './common/system';

export const RatingUnitSchema = z.enum([
  'kw',
  'hp',
  'btu_per_hour',
  'gph_gallon_per_hour',
  'tons_cooling',
]);
export type RatingUnit = z.infer<typeof RatingUnitSchema>;

export const FuelTypeSchema = z.enum(['natural_gas', 'electricity']);
export type FuelType = z.infer<typeof FuelTypeSchema>;

export const AuditMechanicalFormEntrySchema = z.object({
  system: SystemSchema,
  location: z.string(),
  serviceAreaOrEquipment: z.string().optional(),
  type: z.string(),
  tag: z.string(),
  quantity: z.number().optional(),
  make: z.string().optional(),
  model: z.string().optional(),
  powerRating: z.string().optional(), // float value
  ratingUnit: RatingUnitSchema.optional(),
  ratingSource: SourceSchema.optional(),
  fuelType: FuelTypeSchema.optional(),
  efficiency: z.number().optional(),
  efficiencySource: SourceSchema.optional(),
  ventilationRate: z.number().optional(),
  serialNumber: z.string().optional(),
  manufactureDate: isoDateTimeToMoment.optional(), // year and month only
  hours: z.number().optional(),
  control: z.string().optional(),
  other: z.string().optional(),

  attachments: z.array(AttachmentSchema).optional(),
});

export const AuditMechanicalFormSchema = z.object({
  type: z.literal('mechanical'),

  entries: z.array(AuditMechanicalFormEntrySchema),
});

export type AuditMechanicalForm = z.infer<typeof AuditMechanicalFormSchema>;
export type AuditMechanicalFormEntry = z.infer<
  typeof AuditMechanicalFormEntrySchema
>;
